import axios from "axios";
import http from "../http";

const imageUpload = async (file, body) => {
  return await http
    .post(`/assets/get_upload_urls`, body)
    .then(async (res) => {
      const img = res.data.data[0].postUploadImageUrl;
      const putUrl = res.data.data[0].presignedUploadUrl;
      return await axios
        .put(putUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
        })
        .then(async () => {
          return await img;
        })
        .catch((error) => console.error(error));
    })
    .catch((err) => console.error(err));
};

const powerColor = (num) => {
  if (num === "N/A") {
    return "#8B9FC1";
  } else if (num < 26) {
    return "#FFA405";
  } else if (num < 51) {
    return "#FE8A3D";
  } else if (num < 90) {
    return "#ADD001";
  } else if (num >= 90) {
    return "#00C853";
  }
};

export { imageUpload, powerColor };
